<template>
  <canvas ref="canvas"></canvas>
</template>

<script>
export default {
  name: "Crusarder",
  data: function() {
    return {
      context: null,
      cw: 0,
      ch: 0,
      mouse: { x: 0, y: 0 },
      mouseDown: false
    };
  },
  methods: {
    handleMouseMove: function(e) {
      this.mouse.x = e.clientX;
      this.mouse.y = e.clientY;
      this.cw = this.$refs.canvas.width;
      this.ch = this.$refs.canvas.height;
    },
    handleResize: function() {
      this.$refs.canvas.width = window.innerWidth;
      this.$refs.canvas.height = window.innerHeight;
    },
    drawMouse: function() {
      this.context.beginPath();
      this.context.arc(this.mouse.x, this.mouse.y, 13, 0, 2 * Math.PI);
      /* this.context.fillArc(this.mouse.x, this.mouse.y, 20, 0, 2 * Math.PI); */
      this.context.fillStyle = this.mouseDown
        ? "rgba(0,190,87,0.7)"
        : "rgba(0,0,0,0.5)";
      this.context.strokeStyle = this.mouseDown
        ? "rgba(255,255,255,0)"
        : "rgba(255,255,255,0.7)";
      this.context.lineWidth = 2;
      this.context.fill();
      this.context.stroke();
    },
    animate: function() {
      window.requestAnimationFrame(this.animate);
      this.context.clearRect(0, 0, this.cw, this.ch);
      this.drawMouse();
    }
  },
  mounted: function() {
    this.context = this.$refs.canvas.getContext("2d");
    this.animate();
    this.handleResize();
  },
  created: function() {
    window.addEventListener("mousemove", this.handleMouseMove);
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("mouseup", () => {
      this.mouseDown = false;
    });
    window.addEventListener("mousedown", () => {
      this.mouseDown = true;
    });
  },
  destroyed: function() {
    window.removeEventListener("mousemove", this.handleMouseMove);
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("mouseup");
    window.removeEventListener("mousedown");
  }
};
</script>

<style scoped lang="scss">
canvas {
  z-index: 100;
  pointer-events: none;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  @include touchDevice {
    display: none;
  }
}
</style>
